<template>
  <div>
    <v-row>
      <v-col cols="12">
        <router-link :to="{ name: 'newPressRelease' }">
          <v-btn color="primary">{{ $t('press_release.new_press_release') }}</v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <CorrectDataTable
          :table-headers="headers"
          :table-data="press_release_data"
          :page-limit="current_limit"
          :page="current_page"
          :page-limit-options="tablePageLimitOptions"
          :item-total="total_items"
          :is-loading="load_table"
          :enable-search="false"
          :enable-filter="false"
          :enable-date-range="false"
          :enable-clear-all="false"
          :disable-pagination="load_table"
          :disable-sort="true"
          @options-update="onTableChange"
        ></CorrectDataTable>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// = news controller
import { getData } from '@/api'
import CorrectDataTable from '@/components/CorrectDataTable.vue'
import { globalFunc } from '@/global'
export default {
  name: 'PressRelease',
  mixins: [globalFunc],
  components: {
    CorrectDataTable,
  },
  data: () => ({
    headers: [],
    press_release_data: [],
    load_table: true,
    total_items: 0,
    current_page: 1,
    current_limit: 10,
    options: {},
    tablePageLimitOptions: [10, 20, 50],
  }),
  methods: {
    initializeHeader() {
      this.headers = [
        {
          text: this.$t('press_release.publish_date'),
          value: 'publish_date',
          width: '115px',
        },
        {
          text: this.$t('general.title'),
          value: 'title',
        },
        { text: '', value: 'press_release_button', width: '210px' },
      ]
    },
    async getPressReleaseData() {
      try {
        this.load_table = true

        let params = new URLSearchParams()
        params.set(
          'get_published_event',
          JSON.stringify({
            data_type: 'event_data',
            filter_page: this.current_page - 1,
            filter_limit: this.current_limit,
          }),
        )

        let press_release = await getData(params)
        if (Array.isArray(press_release)) {
          this.total_items = 0
          this.press_release_data = []
        } else {
          let temp = []

          this.total_items = press_release.item_count

          for (let i = 0; i < press_release.item_list.length; i++) {
            let obj = press_release.item_list[i]
            temp.push({
              id: obj.id,
              publish_date: obj.publish_date,
              title: obj.title.zh,
            })
          }

          this.press_release_data = temp
        }

        this.load_table = false
      } catch (error) {
        globalFunc.log(error)
        this.load_table = false
      }
    },
    onTableChange(options) {
      if (options.itemsPerPage !== this.current_limit) {
        this.current_page = 1 // reset to first page if view options changed
      } else {
        this.current_page = options.page
      }

      this.current_limit = options.itemsPerPage
      this.getPressReleaseData()
    },
  },
  created() {
    this.initializeHeader()
    this.getPressReleaseData()
  },
}
</script>
